'use client';

import React from 'react';
import { ExperienceType } from '../types';
import GreatForTags from '@/components/stay-experience/GreatForTags';
// import ActivityTitle from '@/components/common/ActivityTitle';

interface ExperienceGreatForProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceGreatFor: React.FC<ExperienceGreatForProps> = ({
  experience,
}) => {
  if (!experience) return null;

  const exp = experience as {
    travellerTypes?: Array<{ title?: string; name?: string } | string>;
  };

  const tags =
    Array.isArray(exp?.travellerTypes) && exp.travellerTypes.length > 0
      ? exp.travellerTypes
          .map(type => {
            if (typeof type === 'string') return type;
            return type?.title || type?.name || '';
          })
          .filter(Boolean)
      : [];

  if (tags.length === 0) return null;

  return (
    <div>
      {/* <ActivityTitle title='Great for' className='' /> */}
      <GreatForTags tags={tags} showLabel={true} />
    </div>
  );
};
